import React, {useState} from 'react';
import {Text, View, TextInput} from 'react-native';

export const TextEntry = ({
  renderElement = true,
  handleChange = () => null,
  value = '',
  label = '',
  inputStyle = {},
  color = global?.color?.gray3,
  placeholder = '',
  placeHolder = '',
  containerStyle = {},
  multiline = false,
  testID = '',
}) => {
  const minHeight = inputStyle?.height || (multiline ? 40 : 25);
  const [height, setHeight] = useState(minHeight);
  if (!renderElement) {
    return <View />;
  }

  return (
    <View style={containerStyle}>
      {!!label && (
        <Text
          style={{
            color: color,
            fontFamily: global?.font.circular,
            marginVertical: 5,
            textAlign: 'left',
            width: 220,
          }}>
          {label}
        </Text>
      )}
      <TextInput
        style={{
          backgroundColor: global?.color?.white1,
          color: color,

          marginBottom: 5,
          width: 220,
          ...inputStyle,
          height,
        }}
        testID={testID}
        onContentSizeChange={(event) => {
          if (!multiline) {
            return;
          }
          setHeight(
            Math.max(minHeight, event.nativeEvent.contentSize.height + 20),
          );
        }}
        allowFontScaling={false}
        textAlign={inputStyle?.textAlign || 'center'}
        multiline={multiline}
        placeholder={placeHolder || placeholder}
        value={value}
        autoCorrect={false}
        underlineColorAndroid={'transparent'}
        onChangeText={(textValue) => handleChange(textValue)}
        blurOnSubmit
      />
    </View>
  );
};
